import { Helmet } from 'react-helmet'
import MainHeader from '../../components/MainHeader'
import MainFooter from '../../components/MainFooter'
import { useEffect, useState } from 'react'
import { motion } from "framer-motion";

import './Linktree.css'
import './MLinktree.css'
import LinkCard from '../../components/LinkCard.js'
import axios from 'axios';
import { URL_STRAPI, API_TOKEN_STRAPI, boxvar2dyndelay, lP } from '../../core.js'
import { useParams } from 'react-router';
import { faInstagram, faLinkedin, faThreads, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function Linktree() {

    let { linkid } = useParams()

    const [linkList, setLinkList] = useState(null);

    const fetchAllLinks = async () => {
        try {
            const res = await axios.get(`${URL_STRAPI}/api/linktrees`, {
                params: {
                    'filters[listed][$eq]': true,
                    // 'sort': 'order:asc',
                    'sort': 'publishedAt:desc',
                    'populate': '*',

                },
                headers: {
                    Authorization: `Bearer ${API_TOKEN_STRAPI}`,
                },
                timeout: 5000, // Timeout nach 5 Sekunden
            });

            return res.data.data;
        } catch (err) {
            console.error('Fehler beim Laden der News:', err.message || err);
            return [];
            // throw err; 
            // oder: return []; wenn du leere Liste willst statt Exception
        }
    };

    useEffect(() => {

        if (linkid != 0 && linkid != undefined && linkid != null) {
            fetchLinkData().then((content) => {
                console.log(content);
                if (content != undefined) {
                    lP(content.url)
                }
            });
        }

        fetchAllLinks().then((content) => { setLinkList(content) });

    }, [])


    const [linkData, setLinkData] = useState(null);

    const fetchLinkData = async () => {
        console.log(linkid);

        const res = await axios.get(`${URL_STRAPI}/api/linktrees`, {
            params: {
                'filters[linkid][$eq]': linkid,
                // 'filters[active][$eq]': true,
                'sort': 'publishedAt:desc',
            },
            headers: {
                Authorization: `Bearer ${API_TOKEN_STRAPI}`,
            },
        });
        console.log(res.data.data[0]);

        return res.data.data[0];
    };


    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={""} disableanimation={true} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToN Linktree</title>
                <meta property="og:title" content="ToNetwork Linktree" />
                <meta property="og:description" content="Die wichtigsten Links und Seiten von ToNetwork" />
                <meta name="description" content="Die wichtigsten Links und Seiten von ToNetwork" />
            </Helmet>
            <section className='sec_next' id='sec_next--linktree'>
                <div className='sec_next_cont' id="sec_next--linktree--cont" style={{ wordBreak: "break-word" }}>
                    <br />
                    <h2>Linktree</h2>
                    <br />
                    <p>Hier findest du alle aktuellen Links und Angebote von ToNetwork, die wir auf unseren Socialmedia Accounts veröffentlich haben.</p>
                    <div className='linktree_socials'>
                        <a href='https://instagram.com/tonetwork.de' title='@tonetwork.de' target='_blank'><FontAwesomeIcon icon={faInstagram} /></a>
                        <a href='https://linkedin.com/company/tonetwork' title='linkedin.com/company/tonetwork' target='_blank'><FontAwesomeIcon icon={faLinkedin} /></a>
                        <a href='https://wa.me/+4915792358626' title='01579 235 8626' target='_blank'><FontAwesomeIcon icon={faWhatsapp} /></a>
                        <a href='https://threads.net/@tonetwork.de' title='@tonetwork.de' target='_blank'><FontAwesomeIcon icon={faThreads} /></a>
                    </div>
                    <br /><br /><br />

                    {(linkList == [] || linkList?.length == 0) ? <p>Es wurden keine Links gefunden 👀</p> :
                        (linkList != null) ? linkList.map(function (linkdata, index) {
                            return (
                                <motion.div key={index} variants={boxvar2dyndelay} custom={0.3 * (index + 1)} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                                    <LinkCard linkid={linkdata.linkid} title={linkdata.title} url={linkdata.url} datum={linkdata.publishedAt} description={linkdata.description} />
                                    <br /><br /><br />
                                </motion.div>
                            )
                        }) : <div>
                            <p>Links werden geladen...</p>

                        </div>}
                    <br /><br /><br /><br /><br /><br /><br />
                    <br /><br /><br /><br /><br /><br /><br />

                </div>
            </section >

            <MainFooter />
        </div >
    )
}